import React from "react";
import Chart from "react-apexcharts";

function SindhTypePrisoner() {
  var options = {
    chart: {
      type: "pie",
      toolbar: {
        show: false,
      },
    },
    colors: ["#C2563A", "#0B2B42", "#2381A2", "#3FA2C4"],
    dataLabels: {
      enabled: true,
      style: {
        colors: ["#ffffff"],
      },
      dropShadow: {
        enabled: false,
      },
    },
    series: [5, 11, 10],
    labels: ["Central Jails", "Distrsict Jails", "Special Prisons"],
    legend: {
      show: false,
    },
  };
  return (
    <div>
      <Chart
        options={options}
        series={options.series}
        type="pie"
        width="100%"
      />
    </div>
  );
}

export default SindhTypePrisoner;
